import {
  type EWarehouseOrderPairingState,
  type EWarehouseOrderStatus,
} from '@mahawi/eshop-common/src/types';
import { Tag } from 'antd';
import React from 'react';

import {
  WAREHOUSE_ORDER_PAIRING_STATE_COLOR,
  WAREHOUSE_ORDER_PAIRING_STATE_LABEL,
  WAREHOUSE_ORDER_STATUS_COLOR,
  WAREHOUSE_ORDER_STATUS_LABEL,
} from './labels';

export function WarehouseOrderStatusTag({
  status,
}: {
  status: EWarehouseOrderStatus;
}): React.ReactElement {
  return (
    <Tag color={WAREHOUSE_ORDER_STATUS_COLOR[status]}>
      {WAREHOUSE_ORDER_STATUS_LABEL[status]}
    </Tag>
  );
}

export function WarehouseOrderPairingStateTag({
  pairingState,
}: {
  pairingState: EWarehouseOrderPairingState;
}): React.ReactElement {
  return (
    <Tag color={WAREHOUSE_ORDER_PAIRING_STATE_COLOR[pairingState]}>
      {WAREHOUSE_ORDER_PAIRING_STATE_LABEL[pairingState]}
    </Tag>
  );
}
